import { get, post } from '@/base/http-base.js'
// 会议日程-主页面列表
export function meetingSchedule(params) {
  return post('/meetingSchedule', params)
}
// 会议日程-根据一级id获取二级
export function getMeetingTypePid(id) {
  return get(`/meetingSchedule/getMeetingType/pId/${id}`)
}
// 会议日程-获取对应级所有数据
export function getMeetingTypeLevelAll(level) {
  return get(`/meetingSchedule/getMeetingType/level/${level}`)
}
